import {get} from "lodash"
import BaseService from "./Base"
import {PhaseDurationUnit} from "types/program-version-phases-and-shifts-templates"

export default class AcademicTrackPhasesAndShiftsTemplatesService extends BaseService {
    addNewPhaseTemplate = async (data: {phaseId: number; academicTrackId: number}): Promise<any> => {
        const response = await this.post("/v1/academic-track/create-new-phase-template", data)
        return get(response, "data.data", {})
    }

    editPhaseTemplate = async (data: {
        phaseTemplates: Array<{
            academicTrackPhaseShiftTemplateId: number
            phaseId?: number
            position?: number
            durationUnit?: PhaseDurationUnit
            duration?: number
        }>
    }): Promise<any> => {
        const response = await this.post("/v1/academic-track/edit-phase-template", data)
        return get(response, "data.data", {})
    }

    deletePhaseTemplate = async (data: {academicTrackPhaseShiftTemplateIds: number[]}): Promise<any> => {
        const response = await this.post("/v1/academic-track/delete-phase-template", data)
        return get(response, "data.data", {})
    }

    getAcademicTrackPhaseTemplates = async (params = {}): Promise<any[]> => {
        const response = await this.post("/v1/academic-track/get-phase-templates", params)
        return get(response, "data.data", [])
    }

    addShiftTemplate = async (data: {shiftIds: number[]; academicTrackPhaseShiftTemplateId: number}) => {
        const response = await this.post("/v1/academic-track/add-shift-template", data)
        return get(response, "data.data", {})
    }

    editShiftTemplate = async (data: {
        shiftTemplates: Array<{
            academicTrackPhaseShiftTemplateShiftId: number
            academicTrackPhaseShiftTemplateId: number
            position: number
        }>
    }) => {
        const response = await this.post("/v1/academic-track/edit-shift-template", data)
        return get(response, "data.data", {})
    }

    deleteShiftTemplate = async (data: {academicTrackPhaseShiftTemplateShiftIds: number[]}) => {
        const response = await this.post("/v1/academic-track/delete-shift-template", data)
        return get(response, "data.data", {})
    }
}
